import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UserService } from 'src/app/components/user-profile/user.service';
import { ToastrService } from 'ngx-toastr';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-change-pwd',
  templateUrl: './change-pwd.component.html',
  styleUrls: ['./change-pwd.component.css']
})
export class ChangePwdComponent implements OnInit {

  isloading = false;
  mform: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    public modalRef:BsModalRef,
    private toastr: ToastrService
  ) {
    this.createForm();
  }

  ngOnInit() {
  }

  createForm() {
    this.mform = this.fb.group({
      opwd: [null, [Validators.required,Validators.maxLength(32)]],
      pwd: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
      cpwd: [null, [Validators.minLength(8), Validators.maxLength(32)]]
    },
    {
      validator: CustomValidator.passwordMatch
    });
  }


  onSubmit() {
    if (this.mform.invalid) {
      return this.mform.markAllAsTouched();
    }
    const f = this.mform.value;
    const o = {
      currentPassword: f.opwd,
      newPassword: f.pwd,
    };
    this.isloading = true;
    this.userService.put_resetPassword(o).subscribe(res => {
      this.isloading = false;
      this.toastr.success('Password successfully changed');
      this.modalRef.hide()
    },
    (error) => {
      this.isloading = false;
      this.toastr.error('Change Password Failed');
    });
  }

  get f() {
    return this.mform.controls;
  }

  invalid(s: string) {
    const m = this.mform.controls[s];
    return m.invalid;
  }

  hasSmallLetter(): boolean {
    const rgx = /^(?=.*[a-z])/.test(this.getPasswords.pwd);
    return !rgx;
  }

  hasNumber(): boolean {
    const rgx = /^(?=.*[0-9])/.test(this.getPasswords.pwd);
    return !rgx;
  }

  get getPasswords() {
    const { pwd, cpwd } = this.mform.getRawValue();
    return { pwd, cpwd };
  }
}
